import { NumberedItem } from '../../ui-components/NumberedItem'
import { EliteScoreTrends, KnowWhyAPIReponseType } from '../../../types/mutual-fund-detail.types'
import { toPascalCaseWithSpaces } from '../../../utils/utils'
import { getScoreConfig } from '../utils'
import { GradientStrip } from '../../ui-components/GradientStrip'
import { StripContent } from './StripContent'
import { formatScoreOfTotalSpeech } from './ScoreValue'

interface VolatilityScoreSectionProps {
  knowWhyData: KnowWhyAPIReponseType
  isElite: boolean
  number: number
  isLastSection: boolean
}

export const VolatilityScoreSection = ({
  knowWhyData,
  isElite,
  number,
  isLastSection
}: VolatilityScoreSectionProps) => {
  const category = toPascalCaseWithSpaces(knowWhyData?.category ?? '')
  const volatilityScore = knowWhyData?.scoringDetails?.volatilityScore ?? 0
  const maxScore = knowWhyData?.scoringDetails?.maxScore ?? 100
  const tag = (knowWhyData?.scoringDetails?.volatilityScorePerformanceTag || EliteScoreTrends.BAD) as EliteScoreTrends
  const config = getScoreConfig(tag)
  const scoreSpeech = formatScoreOfTotalSpeech(isElite ? volatilityScore : null, maxScore, !isElite)
  const description = "Fund's stability during market swings vs others in same category"
  const accessibilityLabel = [
    `Volatility Score in ${category}`,
    scoreSpeech,
    config.scoreLabel,
    description
  ].join(', ')

  return (
    <NumberedItem
      as='li'
      number={number}
      title={`Volatility Score`}
      subtitle={`in ${category}`}
      borderBottom={!isLastSection}
      accessibilityLabel={accessibilityLabel}
    >
      <GradientStrip type={config.gradientStripType}>
        <StripContent
          tag={tag}
          isElite={isElite}
          score={volatilityScore}
          maxScore={maxScore}
          description='Fund’s stability during market swings vs <br /> others in same category'
        />
      </GradientStrip>
    </NumberedItem>
  )
}
